import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, forwardRef } from 'react';
import { TruCaret } from '@uswitch/spark-icons/tru';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var SimpleDropDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var hasError = props.hasError,
      name = props.name,
      value = props.value,
      options = props.options,
      placeholder = props.placeholder,
      isSingleRow = props.isSingleRow,
      _props$handleTrackInt = props.handleTrackInteraction,
      handleTrackInteraction = _props$handleTrackInt === void 0 ? function () {} : _props$handleTrackInt,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasFocus = _useState2[0],
      setHasFocus = _useState2[1];

  var handleOnBlur = function handleOnBlur(e) {
    handleTrackInteraction(e);
    setHasFocus(false);
  };

  var variantPath = isSingleRow ? 'elements.simple-drop-down.singleRow' : 'elements.simple-drop-down';
  var dropdownVariant = hasError ? "".concat(variantPath, ".select.error") : hasFocus ? "".concat(variantPath, ".select.focus") : "".concat(variantPath, ".select.base");
  return _jsxs("div", {
    sx: {
      position: 'relative',
      variant: 'elements.drop-down.container'
    },
    children: [_jsxs("select", {
      name: name,
      value: value,
      onChange: onChange,
      ref: ref,
      onFocus: function onFocus() {
        return setHasFocus(true);
      },
      onBlur: handleOnBlur,
      sx: {
        variant: dropdownVariant
      },
      children: [placeholder ? _jsx("option", {
        value: "",
        disabled: true,
        defaultValue: true,
        children: placeholder
      }) : null, options.map(function (_ref) {
        var label = _ref.label,
            value = _ref.value;
        return _jsx("option", {
          value: value,
          children: label
        }, value);
      })]
    }), _jsx("span", {
      sx: {
        variant: isSingleRow ? 'elements.simple-drop-down.singleRow.span' : 'elements.simple-drop-down.span'
      },
      children: _jsx(TruCaret, {
        color: "black",
        direction: "down",
        sx: {
          transform: 'rotate(0.5turn)'
        }
      })
    })]
  });
});
export default SimpleDropDown;
//# sourceMappingURL=index.js.map